import { render, staticRenderFns } from "./ReportsOld.vue?vue&type=template&id=015af602&scoped=true"
import script from "./ReportsOld.vue?vue&type=script&lang=js"
export * from "./ReportsOld.vue?vue&type=script&lang=js"
import style0 from "./ReportsOld.vue?vue&type=style&index=0&id=015af602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015af602",
  null
  
)

export default component.exports